import { render, staticRenderFns } from "./MainState.vue?vue&type=template&id=1743f812&"
import script from "./MainState.vue?vue&type=script&lang=js&"
export * from "./MainState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports